import { Checkbox } from "@shared/ui/Checkbox";
import { ReactNode } from "react";
import styles from "../styles.module.scss";

interface HubCheckboxRowProps {
  label: string;
  subtitle?: string;
  checked: boolean;
  indeterminate?: boolean;
  onToggle: () => void;
  onLabelClick?: () => void;
  isActive?: boolean;
  nested?: boolean;
  action?: ReactNode;
}

export function HubCheckboxRow({
  label,
  subtitle,
  checked,
  indeterminate = false,
  onToggle,
  onLabelClick,
  isActive = false,
  nested = false,
  action,
}: HubCheckboxRowProps) {
  return (
    <div
      className={`${styles.hubCheckboxRow} ${
        isActive ? styles.hubCheckboxRowActive : ""
      } ${nested ? styles.hubCheckboxRowNested : ""}`}
    >
      <div className={styles.hubCheckboxContent}>
        <Checkbox
          checked={checked}
          indeterminate={indeterminate}
          onChange={() => onToggle()}
        />
        <button
          type="button"
          className={`${styles.hubCheckboxLabelButton} ${
            onLabelClick ? "" : styles.hubCheckboxLabelButtonStatic
          }`}
          onClick={onLabelClick}
          disabled={!onLabelClick}
        >
          <span className={styles.hubCheckboxLabel} title={label}>
            {label}
          </span>
          {subtitle ? (
            <span className={styles.hubCheckboxSubtitle} title={subtitle}>
              {subtitle}
            </span>
          ) : null}
        </button>
      </div>
      {action ? <div className={styles.hubCheckboxAction}>{action}</div> : null}
    </div>
  );
}

export function getFieldSubtitle(field: {
  type?: string;
  defaultValue?: unknown;
}) {
  const parts = [field.type || "text"];

  if (
    field.defaultValue !== undefined &&
    field.defaultValue !== null &&
    field.defaultValue !== ""
  ) {
    parts.push(
      `Default: ${
        Array.isArray(field.defaultValue)
          ? field.defaultValue.join(", ")
          : String(field.defaultValue)
      }`
    );
  }

  return parts.join(" · ");
}
